<script setup lang="ts">
import { openLoginDialog } from '@/components/content/loginDialog/login';
import { openMemberDialog } from '@/components/content/memberDialog/member';
import { serviceUrl } from '@/config/apiDomain';
import useStore from '@/stores/publicStore';
import { removeStorage } from '@/utils/storage';
import { step } from '@/views/home/slidePPT/use/data';
import { storeToRefs } from 'pinia';

const { isLogin, isVip, userInfo, vipInfo } = storeToRefs(useStore());
const router = useRouter();

const goToLogin = () => {
  openLoginDialog();
};
const logoutLogin = () => {
  removeStorage('token');
  isLogin.value = false;
  ElMessage.success('已退出登录');
};
const goPurchaseMembership = () => {
  if (!isLogin.value) {
    ElMessage.warning('请先登录');
    goToLogin();
    return;
  }
  openMemberDialog();
};
const linkToService = () => {
  window.open(serviceUrl, '_blank');
};
const linkTheme = () => {
  step.value = 'theme';
  router.push('/slideppt');
};

const linkProduct = () => {
  router.push('/product');
};
</script>

<template>
  <div h-64 flex-align justify-between solid-border border-0 border-b-1 border="#e3e8ec">
    <div flex-align w-full mx-30>
      <div flex-1 truncate flex-align cursor-pointer @click="linkTheme">
        <CsdImg :src="`/images/header-title.png`" class="w-122 mr-5" />
      </div>
      <div flex-align>
        <div
          flex-align
          mr-17
          h-32
          justify-center
          rounded-full
          cursor-pointer
          v-if="!isVip"
          @click="goPurchaseMembership"
        >
          <CsdImg :src="`/images/member.png`" class="!w-16 !h-14" />
          <span text-12 ml-5> 开通会员 </span>
        </div>
        <div class="primary-button w-70 h-30 rounded-full" v-if="!isLogin" @click="goToLogin">
          登录
        </div>
        <el-popover v-else>
          <div w-172 py-15>
            <div h-50 pl-20 flex-align text-12>
              <div size-40 relative mr-6 rounded-full>
                <div solid-border border-2 border="#567DE6" rounded-full>
                  <CsdImg :src="`/images/avatar.png`" class="size-36" />
                </div>
                <div absolute r-0 b-0 v-if="isVip">
                  <CsdImg :src="`/images/is-vip.png`" class="!size-16" />
                </div>
              </div>
              ID: {{ userInfo.uid }}
            </div>
            <div
              h-36
              pl-25
              flex-align
              hover:bg="#F4F4F4"
              cursor-pointer
              text-12
              @click="goPurchaseMembership"
            >
              <CsdImg :src="`/images/member.png`" class="w-16 mr-7" />
              <div v-if="!isVip">开通会员</div>
              <div v-else>
                <span>{{ vipInfo.expiry.split(' ')[0].replaceAll('-', '/') }}</span>
                <span ml-6 text="#4C83FC" cursor-pointer> 续费 </span>
              </div>
            </div>
            <div
              h-36
              pl-25
              flex-align
              hover:bg="#F4F4F4"
              cursor-pointer
              text-12
              @click="linkProduct"
            >
              <span class="iconfont ppt-edit mr-7 scale-90"></span>
              我的作品
            </div>
            <div
              h-36
              pl-25
              flex-align
              hover:bg="#F4F4F4"
              cursor-pointer
              text-12
              @click="linkToService"
            >
              <span class="iconfont ppt-service mr-7"></span>
              联系客服
            </div>
            <div
              h-36
              pl-25
              flex-align
              hover:bg="#F4F4F4"
              cursor-pointer
              text-12
              @click="logoutLogin"
            >
              <span class="iconfont ppt-quit mr-7"></span>
              退出账号
            </div>
          </div>
          <template #reference>
            <div flex-center class="top-bar-btn relative">
              <div solid-border border-2 border="#567DE6" rounded-full>
                <CsdImg :src="`/images/avatar.png`" class="!size-36" />
              </div>
              <div absolute r-0 b-0 v-if="isVip">
                <CsdImg :src="`/images/is-vip.png`" class="!size-16" />
              </div>
            </div>
          </template>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.top-bar-btn {
  cursor: pointer;
}
.avatar-popover {
  border-radius: 10px !important;

  .el-popper__arrow::before {
    display: none;
  }
}
</style>
